import { useEffect, useState } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';

const NewUsers = () => {
  const { user } = useAuth();

  const [showDialog, setShowDialog] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [reload, setReload] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const getUploadsAPI = useAPI(searchAPI.getUploadsByUser);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('searc state', state);
    console.log('use ef rows', selectedRows);
    setSelectedRows(selectedRows);

    getUploadsAPI.request();//.then(res => {console.log('res load', getSearchResultsAPI.data.Results)});

    setReload(false);
  }, [reload]);

 
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Date Added', width: 170 },
    { field: 'ticStaff', headerName: 'First Name', width: 170 },
    { field: 'date', headerName: 'Last Name', width: 170 },
    { field: 'park', headerName: 'Email', width: 170 },
    { field: 'attachment', headerName: 'Phone', width: 170 },
    { field: 'status', headerName: 'Position', width: 170 }
  ];
  
  return (
    <>
    {/* <h1>User Uploads: {user?.profile?.name}</h1> */}
    <h1 className="center">New Users</h1>

      <div className="search-results">
        {getUploadsAPI.error && <p>{getUploadsAPI.error}</p>}
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={[].map((result, index) => (
              {
               
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            
            loading={getUploadsAPI.loading}
          />
        </div>
      </div>
    </>
  );
}

export default NewUsers;